import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import { Tooltip } from '@src/components/Tooltip';
import { relativeTime } from '@src/util/relativeTime';
import FrMegaphoneSvg from '@src/svgs/megaphone-blue.svg';
import { TimestampProps } from './props';

import './styles.scss';

export const Timestamp: FC<TimestampProps> = ({ userName, publishedAt }) => {
  return (
    <div className="ta-carousel-card-timestamp">
      <Tooltip
        overlay={
          <span>
            {userName} is open for job offers <br />
            sent through MeetFrank.
            <br />
            You can invite {userName} to apply.
          </span>
        }
        placement="bottom"
      >
        <div className="ta-carousel-card-timestamp__timestamp">
          <Svg src={FrMegaphoneSvg} className="featured-talent-card__time-megaphone" />
          {relativeTime(publishedAt, false)}
        </div>
      </Tooltip>
    </div>
  );
};
